import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import '../../styles/Edit.css';
import { updateWorkPhone } from '../../utils/api';
import { BIOBANK_ROUTES } from '../../constants/routes';

const EditWorkPhone = () => {
  const [phoneNumber, setPhoneNumber] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handlePhoneNumberChange = (e) => {
    setPhoneNumber(e.target.value);
  };

  const validatePhoneNumber = () => {
    const phoneRegex = /^\d{3}-\d{3}-\d{4}$/;
    if (!phoneRegex.test(phoneNumber)) {
      setError('Phone number must be in the format XXX-XXX-XXXX');
      return false;
    }
    setError('');
    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validatePhoneNumber()) {
      try {
        await updateWorkPhone(phoneNumber);
        navigate(BIOBANK_ROUTES.PROFILE);
      } catch (error) {
        console.error('Error saving phone number:', error);
        setError('Failed to save phone number. Please try again.');
      }
    }
  };

  const handleCancel = () => {
    navigate(BIOBANK_ROUTES.PROFILE);
  };

  return (
    <div className="edit-wrapper">
      <div className="edit-container">
        <div className="edit-header">
          <h2>Edit Work Phone</h2>
          <button className="close-btn" onClick={handleCancel}>X</button>
        </div>
        {error && <p className="error-message">{error}</p>}
        <form onSubmit={handleSubmit}>
          <div className="edit-content">
            <div className="phone-input-container"> 
              <label htmlFor="workPhone">Work Phone</label>
              <input
                type="tel"
                id="workPhone"
                value={phoneNumber}
                onChange={handlePhoneNumberChange}
                placeholder="XXX-XXX-XXXX"
                className={error ? 'error-border' : ''}
              />
            </div>
          </div>
          <div className="button-group">
            <button type="submit" className="save-btn">Save</button>
            <button type="button" className="cancel-btn" onClick={handleCancel}>Cancel</button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditWorkPhone;